import React from 'react';
import Sidebar from '../../components/common/Sidebar';
import Navbar from '../../components/common/Navbar';
import ExtraWorkForm from '../components/forms/ExtraWorkForm';
import '../../wrms/css/wrms.css';

const ExtraWorkPage = () => (
  <div className="d-flex wrms-page">
    <Sidebar />
    <div className="flex-grow-1">
      <Navbar />
      <div className="wrms-container">
        <div style={{ maxWidth: '900px', margin: '0 auto' }}>
          <div className="wrms-page-header">
            <div className="wrms-breadcrumb">Requests · <span>Extra Work</span></div>
            <h1 className="wrms-page-title">Log Extra Work</h1>
            <p className="wrms-page-subtitle">Log extra working hours. May generate Comp Off or Overtime pay.</p>
          </div>
          <div className="wrms-card" style={{ overflow: 'hidden' }}>
            <ExtraWorkForm />
          </div>
        </div>
      </div>
    </div>
  </div>
);

export default ExtraWorkPage;
